'use strict';

export default function routes($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/", "/main/list");
  $urlRouterProvider.when("/main", "/main/list");
  $stateProvider.state('main', {
      url: '/main',
      template: require('./main.html'),
      authenticate: true
    })
    .state('main.list', {
      url: '/list?page&search',
      template: require('./list/list.html'),
      controller: 'ReportListController',
      controllerAs: 'rListCtrl',
      authenticate: true
    })
    .state('main.show', {
      url: '/:id',
      template: require('./show/show.html'),
      controller: 'ReportShowController',
      controllerAs: 'rShowCtrl',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/main/main.routes.js